<template>
  <app-base-main>
    <template #filter-group>
      <app-filter-group>
        <gj-country-server-select
          v-model="filter.marketIds"
        ></gj-country-server-select>
        <gj-select-input
          v-model="filter.keyword"
          :options="[
              {id: 'asin', text: 'ASIN'},
              {id: 'msku', text: 'MSKU'},
          ]"
        ></gj-select-input>
        <gj-date-picker
          type="daterange"
          v-model="filter.purchaseDate"
          :clearable="false"
        ></gj-date-picker>
        <template #right>
          <gj-button v-if="$permission('promotionAnalysis:excludePromotionId')" type="primary" @click="filterPromotionCode">排除促销编码</gj-button>
          <gj-tool-group
            setting
            :table-name="tableName"
            :table-columns="columns"
            help
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
        :data="data"
        :columns="columns"
      >
        <template v-slot:op="{ row }">
          <gj-button type="text" @click="openDetail(row)">详情</gj-button>
          <gj-button v-if="$permission('order:view')" type="text" @click="openPromotionOrder(row)">促销订单</gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {startOfMonth} from 'date-fns';
  import PromotionAnalysisFilter from './modal/promotion-analysis-filter';
  import PromotionAnalysisDetail from './modal/promotion-analysis-detail';
  import {convertToFullDate} from "../../../../utils/date.util";

    export default {
        name: "promotion-analysis",
        data() {
            return {
                tableName: 'promotionAnalysis',
                filter: {
                    keyword: {
                        key: 'asin',
                        value: null,
                    },
                    marketIds: null,
                    purchaseDate: [startOfMonth(new Date()), new Date()],
                    promotionCodes: [],
                },
                data: [
                    {
                        msku: 'aaa',
                    }
                ],
                columns: [
                    {id: 'marketId', header: '店铺/国家', field: 'marketName', minWidth: '120px', fixed: 'left', default: true, disabled: true},
                    {id: 'picture', header: '图片', field: 'picture:picture', minWidth: '60px', fixed: 'left', default: true, disabled: true, },
                    {id: 'listingInfo', header: '商品标题/ASIN/MSKU', field: 'slot:listingInfo', minWidth: '280px', fixed: 'left', default: true, disabled: true, },
                    {id: 'listingInfo1', header: '单价/折后均价', field: 'listingInfo', minWidth: '120px', default: true, },
                    {id: 'listingInfo2', header: '兑换数', field: 'listingInfo', minWidth: '120px', default: true, },
                    {id: 'listingInfo3', header: '促销花费', field: 'listingInfo', minWidth: '120px', default: true, },
                    {id: 'listingInfo4', header: '促销毛利', field: 'listingInfo', minWidth: '120px', default: true, },
                    {id: 'listingInfo5', header: '促销销量', field: 'listingInfo', minWidth: '120px', default: true, },
                    {id: 'listingInfo6', header: '总销量', field: 'listingInfo', minWidth: '120px', },
                    {id: 'listingInfo7', header: '促销销量占比', field: 'listingInfo', minWidth: '120px', default: true, help: '促销销量占比=促销销量/总销量'},
                    {id: 'picture1', header: '促销销售额', field: 'listingInfo', minWidth: '120px', default: true, },
                    {id: 'picture2', header: '总销售额', field: 'listingInfo', minWidth: '120px', default: true, },
                    {id: 'picture3', header: '促销销售额占比', field: 'listingInfo', minWidth: '120px', default: true, help: '促销销售额占比=促销销售额/总销售额' },
                    {id: 'picture4', header: '促销折扣', field: 'listingInfo', minWidth: '120px', default: true, },
                    {id: 'picture5', header: '促销退货量', field: 'listingInfo', minWidth: '120px',},
                    {id: 'picture6', header: '促销退货率', field: 'listingInfo', minWidth: '120px', default: true, help: '促销退货率=促销退货量/促销销量'},
                    {id: 'picture7', header: '促销退款量', field: 'listingInfo', minWidth: '120px', },
                    {id: 'picture8', header: '促销退款率', field: 'listingInfo', minWidth: '120px', default: true, help: '促销退款率=促销退款量/促销销量'},
                    {id: 'picture9', header: '促销取消量', field: 'listingInfo', minWidth: '120px',},
                    {id: 'picture0', header: '促销取消率', field: 'listingInfo', minWidth: '120px', default: true, help: '促销取消率=促销取消量/促销销量'},
                    {id: 'op', header: '操作', field: 'slot:op', minWidth: '120px', fixed: 'right', default: true, notCustomColumn: true}
                ],
            }
        },
        methods: {
            openDetail(row) {
              this.$gjCreate(PromotionAnalysisDetail)
            },
            openPromotionOrder(row) {
              this.$router.push({path: `/sale/saleOrder`,
                  query: {link: 'promotionAnalysis',
                      msku: row.msku, promotion: true, purchaseDate: [convertToFullDate(this.filter.purchaseDate[0], 'yyyy-MM-dd'),
                          convertToFullDate(this.filter.purchaseDate[1], 'yyyy-MM-dd')]}})
            },
            filterPromotionCode() {
                const modal = this.$gjCreate(PromotionAnalysisFilter, {
                    props: {
                        filterList: this.filter.promotionCodes,
                    },
                    on: {
                        confirm: () => {
                            this.filter.promotionCodes = modal.rightList;
                            modal.$gjDestroy()
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
